/* eslint-disable react/no-array-index-key, react/jsx-one-expression-per-line */
import React from 'react'
import PropTypes from 'prop-types'
import { t, Trans } from '@lingui/macro'

import ImageTextSection from '../../../../components/common/ImageTextSection'

import scanCode from '../../../../../assets/instructions/scan_code.png'

export const SCAN_QR_STEP = {
  heading: t`Scan code with Yoti`,
  toggled: true,
  canBeToggled: false,
  paragraphs: [
    <Trans><p>Log in to your Yoti app.</p></Trans>,
    <Trans><p>Tap <b>Scan</b> at the bottom of the screen.</p></Trans>,
    <Trans><p>Scan the Yoti QR code below:</p></Trans>
  ],
  imgSrc: scanCode
}

export const SHARE_LINK_STEP = {
  heading: t`Share details using Yoti`,
  toggled: true,
  canBeToggled: false,
  paragraphs: [
    <Trans><p>Tap the Yoti button to open your Yoti app and share the details.</p></Trans>,
  ]
}

const ShareStep = ({ qrCodeDisplayed }) => {
  const {
    heading,
    toggled,
    canBeToggled,
    paragraphs,
    imgSrc
  } = qrCodeDisplayed ? SCAN_QR_STEP : SHARE_LINK_STEP

  return (
    <ImageTextSection
      contentToggled={toggled}
      contentToggleEnabled={canBeToggled}
      {...(imgSrc && { imgSrc })}
    >
      <h6 className="instructions-section__header">
        <Trans id={heading} />
      </h6>
      { paragraphs.map((p, key) => React.cloneElement(p, { key }))}
    </ImageTextSection>
  )
}

ShareStep.propTypes = {
  qrCodeDisplayed: PropTypes.bool.isRequired
}

export default ShareStep
